(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('tax-class', {
            parent: 'entity',
            url: '/tax-class?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.taxClass.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/tax-class/tax-classes.html',
                    controller: 'TaxClassController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('taxClass');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('tax-class-detail', {
            parent: 'entity',
            url: '/tax-class/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.taxClass.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/tax-class/tax-class-detail.html',
                    controller: 'TaxClassDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('taxClass');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'TaxClass', function($stateParams, TaxClass) {
                    return TaxClass.get({id : $stateParams.id});
                }]
            }
        })
        .state('tax-class.new', {
            parent: 'tax-class',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tax-class/tax-class-dialog.html',
                    controller: 'TaxClassDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('tax-class', null, { reload: true });
                }, function() {
                    $state.go('tax-class');
                });
            }]
        })
        .state('tax-class.edit', {
            parent: 'tax-class',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tax-class/tax-class-dialog.html',
                    controller: 'TaxClassDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TaxClass', function(TaxClass) {
                            return TaxClass.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('tax-class', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('tax-class.delete', {
            parent: 'tax-class',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tax-class/tax-class-delete-dialog.html',
                    controller: 'TaxClassDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['TaxClass', function(TaxClass) {
                            return TaxClass.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('tax-class', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
